import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { Interview } from '@app/models/recruiting/interview.model';
import { AnalyticService, NotifyService } from '@app/services';
import { ShowView } from '@common/views';

@Component({
    selector: 'app-job-posting-interviews-show',
    templateUrl: './job-posting-interviews-show.template.html',
    styleUrls: ['./job-posting-interviews-show.style.scss'],
})
export class JobPostingInterviewsShowView extends ShowView {
    interview: Interview;
    isLoading = false;
    isDeleteInterviewConfirmationDialog = false;

    constructor(
        private route: ActivatedRoute,
        private notify: NotifyService,
        private router: Router,
        private analyticService: AnalyticService
    ) {
        super();
        this.interview = this.route.snapshot.data.models.get('interview');
    }

    editInterview(): void {
        this.router.navigate([
            '/recruiting',
            'jobPostings',
            this.interview.atsJobId,
            'interviews',
            this.interview.id,
            'edit',
        ]);
    }

    openDeleteInterviewConfirmationDialog(): void {
        this.isDeleteInterviewConfirmationDialog = true;
    }

    closeDeleteInterviewConfirmationDialog(): void {
        this.isDeleteInterviewConfirmationDialog = false;
    }

    onCancel(): void {
        return;
    }

    onSave(): void {
        return;
    }

    async onDelete(): Promise<void> {
        this.isLoading = true;
        try {
            await this.interview.delete();
            this.analyticService.trackEvent(AnalyticEvents.RecruitingJobPostingInterviewsDeleteInterview);
            this.notify.success({
                key: 'applicant-tracker.failedOnDeletingInterview',
                params: {
                    interviewName: this.interview.name,
                },
            });
            this.router.navigate(['/recruiting', 'jobPostings', this.interview.atsJobId, 'interviews']);
        } catch (err) {
            this.notify.error(err || 'applicant-tracker.failedOnDeletingInterview');
        }

        this.isLoading = false;
    }
}
